import { environment } from '../../environments/environment';

// docs/design/01_architecture.md §3 — Angular Ops Console talks to the ASP.NET Core API.
// The actual URL is swapped per deployment target via angular.json's fileReplacements
// (src/environments/environment.{dev,test,staging,prod}.ts).
export const API_BASE_URL = environment.apiBaseUrl;
